import { ResourceCentrePageCategoryItem } from '../../../types';

export const translations: ResourceCentrePageCategoryItem = {
  title: 'Carte santé',
  content: [
    'Si votre carte d’assurance maladie a été perdue ou volée, il est important de la remplacer immédiatement afin d’avoir accès aux services de soins de santé essentiels au besoin. Les mesures à prendre pour remplacer votre carte d’assurance maladie varient d’une province à l’autre. Vous trouverez ci-dessous les étapes à suivre pour chaque province :',

    '<h6>Alberta</h6>',
    '<ul>',
    '<li>Vous pouvez demander une nouvelle carte :',
    '<ul>',
    '<li>Par téléphone au <a  href="tel:780-427-1432">780-427-1432</a> à Edmonton, ou ailleurs sans frais en',
    'Alberta au 1-310-0000, puis au <a  href="tel:780-427-1432">780-427-1432</a>.</li>',
    '<li>En écrivant à Alberta Health, à l&#39;attention de : Alberta Health Care Insurance Plan, P.O. Box 1360,',
    'Station Main, Edmonton, AB T5J 2N3</li>',
    '<li>En personne, en visitant un agent des enregistrements autorisé.</li>',
    '</ul>',
    '</li>',
    '<li>Vous devez fournir votre nom complet, votre adresse postale, votre numéro de téléphone, votre numéro',
    'personnel de soins de santé et votre date de naissance.</li>',
    '<li>Visitez le site Web du Régime d’assurance maladie de l’Alberta pour vous assurer que ces renseignements sont toujours valables.</li>',
    '</ul>',

    '<h6>Saskatchewan</h6>',
    '<ul>',
    '<li>Votre carte santé peut être facilement remplacée en ligne.</li>',
    '<li>Vous pouvez aussi imprimer et remplir ce document, puis l’envoyer',
    'par courrier ou par télécopieur à l’aide des coordonnées inscrites sur le formulaire.</li>',
    '</ul>',

    '<h6>Manitoba</h6>',
    '<ul>',
    '<li>Vous pouvez remplacer facilement votre carte santé en remplissant le formulaire en ligne.</li>',
    '<li>Vous pouvez également communiquer immédiatement avec la Direction des services assurés en composant le',
    '<a  href="tel:+1- 204-786-7101">204-786-7101</a> (Winnipeg) ou le numéro sans frais',
    '<a  href="tel:+1-800-392-1207">1-800-392-1207</a>. Appelez le Manitoba Relay Service au 711 ou au',
    '<a  href="tel:+1-800-432-4444">1-800-432-4444</a> pour rejoindre la ligne téléphonique ci-dessus.</li>',
    '<li>Visitez le site Web de l&#39;assurance des soins de santé du Manitoba pour vous assurer que ces',
    'renseignements sont toujours valables.</li>',
    '</ul>',

    '<h6>Ontario</h6>',
    '<ul>',
    '<li>Si votre nom et votre adresse n&#39;ont pas changé, vous pouvez demander une nouvelle carte en composant le',
    '<a  href="tel:+1-800-664-8988">1-800-664-8988</a>.</li>',
    '<li>Si vous avez une ancienne carte santé (rouge et blanche), si votre carte santé est expirée ou si vos',
    'coordonnées ont changé, vous devez vous rendre dans un centre ServiceOntario. Vous devrez apporter 3 documents originaux :',
    '<ul>',
    '<li>un pour prouver votre citoyenneté ou votre statut d&#39;immigrant;</li>',
    '<li>un pour prouver que vous résidez en Ontario;</li>',
    '<li>un pour prouver votre identité.</li>',
    '</ul>',
    '</li>',
    '</ul>',

    '<h6>Québec</h6>',
    '<ul>',
    '<li>Vous pouvez demander une nouvelle carte en remplissant le formulaire en ligne, moyennant des frais minimes.</li>',
    '<li>Vous pouvez également demander une nouvelle carte en appelant la Régie au',
    '<a  href="tel:+1-800-561-9749">1-800-561-9749</a> (sans frais) ou au <a  href="tel:514-864-3411">514-864-3411</a>',
    'de Montréal ou Québec, moyennant des frais supplémentaires.</li>',
    '<li>Pour obtenir une nouvelle carte en personne, visitez l&#39;un des points de service de la Régie.</li>',
    '<li>Pour plus de commodité, vous pouvez remplacer à la fois votre carte d&#39;assurance maladie et votre permis de',
    'conduire dans l&#39;un des points de service de la Société de l&#39;assurance automobile du Québec (SAAQ)',
    'en utilisant la même photo.</li>',
    '</ul>',

    '<h6>Terre-Neuve-et-Labrador</h6>',
    '<ul>',
    '<li>Remplissez le formulaire de demande de nouvelle carte et retournez-le par la poste ou en personne au régime',
    'd&#39;assurance maladie.</li>',
    '<li>Les formulaires sont disponibles dans la plupart des cabinets de médecins et des hôpitaux de',
    'Terre-Neuve-et-Labrador et au bureau du régime d&#39;assurance maladie, situé au 45, chemin Major, à St. John&#39;s.',
    'Vous pouvez également imprimer vos propres formulaires.</li>',
    '<li>Si vous ne connaissez pas votre numéro de régime d&#39;assurance maladie, vous devrez fournir une pièce d&#39;identité',
    'avant de recevoir une nouvelle carte.</li>',
    '</ul>',

    '<h6>Nouveau-Brunswick</h6>',
    '<ul>',
    '<li>Visitez votre bureau local de Service Nouveau-Brunswick pour demander une nouvelle carte, moyennant des frais minimes.</li>',
    '<li>Vous pouvez également poster un chèque ou un mandat libellé à l&#39;ordre du ministre des Finances, accompagné',
    'de votre formulaire de demande de remplacement dûment rempli.</li>',
    '<li>Pour toute question relative au formulaire, vous pouvez communiquer sans frais avec les Téléservices de',
    'Services Nouveau-Brunswick au <a  href="tel:+1-888-762-8600">1-888-762-8600</a>.</li>',
    '<li>Vous trouverez la liste des pièces justificatives sur le formulaire de demande de remplacement.</li>',
    '</ul>',

    '<h6>Nouvelle-Écosse</h6>',
    '<ul>',
    '<li>Communiquez avec le service d&#39;inscription et de renseignements du régime d&#39;assurance de services médicaux',
    '(MSI) pour demander une nouvelle carte par téléphone au <a  href="tel:902-496-7008">902-496-7008</a> ou au',
    '<a  href="tel:+1-800-563-8880">1-800-563-8880</a> (sans frais en Nouvelle-Écosse) ou par',
    'courriel à <a  href="mailto:MSI@medavie.ca">MSI@medavie.ca</a>. Des frais minimes s&#39;appliquent.</li>',
    '</ul>',

    '<h6>Île-du-Prince-Édouard</h6>',
    '<ul>',
    '<li>Renvoyez votre formulaire de demande de remplacement de la carte santé pour demander une nouvelle carte,',
    'moyennant des frais minimes.</li>',
    '<li>Si vous avez besoin d&#39;informations supplémentaires concernant le formulaire ou le processus, vous pouvez',
    'contacter Medicare Services au <a  href="tel:+1-800-321-5492">1-800-321-5492</a>.</li>',
    '</ul>'
  ].join('\n')
};
